<template>
    <div class="container-fluid p-doctors">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">医師一覧</div>
                    <div class="card-body p-doctors__content pt-3">
                        <div class="d-block d-md-flex justify-content-between mb-3">
                            <div class="d-block d-md-flex flex-wrap align-items-center">
                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="input-group input-group-sm">
                                        <select
                                            v-model="search.medical_course_id"
                                            @change="onChangeSearchMedicalCourseId"
                                            style="min-width: 200px;"
                                            class="form-control">
                                            <option :value="null">{{ $locale.consultation_host }}科で検索</option>
                                            <option
                                                v-for="medicalCourse in medicalCourses"
                                                :key="`medical_course_id_${medicalCourse.id}`"
                                                :value="medicalCourse.id">
                                                {{ medicalCourse.name }}
                                            </option>
                                            <option value="all">すべての{{ $locale.consultation_host }}科</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="input-group input-group-sm">
                                        <select
                                            v-model="search.doctor_management_tag_id"
                                            @change="onChangeSearchDoctorManagementTagId"
                                            id="doctor_management_tag_id"
                                            style="min-width: 100px;"
                                            class="form-control">
                                            <option :value="null">管理用タグで検索</option>
                                            <option
                                                v-for="doctorManagementTag in doctorManagementTags"
                                                :key="`doctor_management_tag_id_${doctorManagementTag.id}`"
                                                :value="doctorManagementTag.id">
                                                {{ doctorManagementTag.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="input-group input-group-sm">
                                        <select
                                            v-model="search.prefecture"
                                            @change="onChangeSearchPrefecture"
                                            id="prefmap"
                                            style="min-width: 100px;"
                                            class="form-control">
                                            <option :value="null">都道府県で検索</option>
                                            <option
                                                v-for="(pref, index) in prefmap"
                                                :key="`pref_${index}`"
                                                :value="pref">
                                                {{ pref }}
                                            </option>
                                            <option value="all">すべての地域</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-2 mb-2 mr-md-2 mb-md-0">
                                    <div class="c-freeword input-group input-group-sm">
                                        <input
                                            v-model="search.freeword"
                                            @change="onChangeSearchFreeword"
                                            type="text"
                                            class="form-control"
                                            placeholder="フリーワード"
                                            aria-label="Recipient's username"
                                            aria-describedby="basic-addon2">
                                        <div class="input-group-append">
                                            <div
                                                class="c-freeword__btn input-group-text" id="basic-addon2"
                                                @click="onChangeSearchFreeword">
                                                検索
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                    <div class="input-group input-group-sm">
                                        <select
                                            v-model="search.status"
                                            @change="onChangeSearchStatus"
                                            id="status"
                                            style="min-width: 100px;"
                                            class="form-control">
                                            <option :value="null">ステータスで検索</option>
                                            <option
                                                v-for="(status, index) in statusItems"
                                                :key="`status_${index}`"
                                                :value="status">
                                                {{ status }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="d-block d-md-flex align-items-center">
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <span class="small">登録日</span>
                                    </div>
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                v-model="search.registered_at_gte"
                                                @change="onChangeSearchRegisteredAtGte"
                                                type="date"
                                                class="form-control">
                                        </div>
                                    </div>
                                    <span class="small mt-2 ml-2">〜</span>
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                v-model="search.registered_at_lte"
                                                @change="onChangeSearchRegisteredAtLte"
                                                type="date"
                                                class="form-control">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="text-center text-md-right">
                                <button
                                    type="button"
                                    class="btn btn-yokumiru-orange"
                                    style="min-width: 100px;"
                                    @click="showModalAddDoctor()">
                                    医師追加
                                </button>
                            </div>
                        </div>

                        <div
                            v-if="doctors !== null"
                            class="adminDoctorsIndexTable">
                            <b-table
                                striped
                                hover
                                responsive
                                :items="doctors"
                                :fields="fields"
                                :sort-by.sync="$store.state.adminDoctors.sortBy"
                                :sort-desc.sync="$store.state.adminDoctors.sortDesc"
                                @sort-changed="fetchDoctors"
                                class="table-bordered m-table">
                                <template v-slot:cell(full_name_kana)="data">
                                    <a href="#" @click="showModalDoctorProfile(data.item.id, $event)">
                                        {{ data.item.full_name }}
                                    </a>
                                    <div class="small">{{data.item.full_name_kana}}</div>
                                </template>

                                <template v-slot:cell(medical_course.name)="data">
                                    <div>{{ medicalCoursesFormat(data.item.medical_courses) }}</div>
                                </template>

                                <template v-slot:cell(doctor_management_tags.name)="data">
                                    <div class="doctorManagementTagsWrapper d-flex align-items-center">
                                        <div
                                            v-for="tag in data.item.doctor_management_tags"
                                            class="d-flex align-baseline">
                                            <div class="doctorManagementTag d-flex justify-content-center align-items-center">{{ tag.name }}</div>
                                        </div>
                                    </div>
                                </template>

                                <template v-slot:cell(status)="data">
                                    <b-button
                                        v-if="data.item.restricted_at != null"
                                        type="button"
                                        class="btn btn-warning btn-sm w-100"
                                        @click="showModalUnrestrictDoctor(data.item)">
                                        制限中
                                    </b-button>
                                    <div v-else>
                                        <b-button
                                            v-if="data.item.stopped_at == null"
                                            type="button"
                                            class="btn btn-success btn-sm w-100"
                                            @click="showModalStopDoctor(data.item)">
                                            利用中
                                        </b-button>
                                        <b-button
                                            v-if="data.item.stopped_at != null"
                                            type="button"
                                            class="btn btn-metal btn-sm w-100"
                                            @click="showModalComebackDoctor(data.item)">
                                            利用停止中
                                        </b-button>
                                    </div>
                                </template>

                                <template v-slot:cell(address)="data">
                                    <div v-show="data.item.postcode !== null">〒{{ data.item.postcode }}</div>
                                    <div>
                                        <span v-show="data.item.address !== null">{{ data.item.prefecture }}</span>
                                        <span v-show="data.item.prefecture !== null">{{ data.item.address }}</span>
                                    </div>
                                    <div v-if="data.item.building !== null">{{ data.item.building }}</div>
                                </template>

                                <template v-slot:cell(sms_setting)="data">
                                    <div v-if="!data.item.tel" class="text-muted">未設定</div>
                                    <div v-else-if="!data.item.doctor_metadata.sms_sent_at">未送信</div>
                                    <div v-else-if="data.item.doctor_metadata.is_sms_success" class="text-success">到達</div>
                                    <div v-else-if="!data.item.doctor_metadata.is_sms_success" class="text-danger">失敗</div>
                                </template>

                                <template v-slot:cell(links)="data">
                                    <b-button
                                        type="button"
                                        class="btn btn-yokumiru-ash btn-sm m-2"
                                        :href="`/admin/doctors/${data.item.id}/settings`">
                                        設定
                                    </b-button>
                                    <b-button
                                        type="button"
                                        class="btn btn-yokumiru-blue btn-sm m-2"
                                        @click="showModalEditDoctor(data.item)">
                                        編集
                                    </b-button>
                                    <b-button
                                        type="button"
                                        class="btn btn-danger btn-sm m-2"
                                        @click="showModalDeleteDoctor(data.item)">
                                        削除
                                    </b-button>
                                </template>
                            </b-table>

                            <div class="d-flex justify-content-between align-items-center">
                                <b-pagination
                                    :total-rows="$store.state.adminDoctors.total"
                                    :per-page="$store.state.adminDoctors.per_page"
                                    v-model="$store.state.adminDoctors.current_page"
                                    @change="fetchDoctors">
                                </b-pagination>

                                <div class="d-flex flex-wrap align-items-center">
                                    <div class="mb-3 mr-2">
                                        <span class="small">{{ dispPaginationDetail }}</span>
                                    </div>
                                    <div class="mb-3">
                                        <b-button
                                            variant="yokumiru-orange"
                                            @click="downloadCSV"
                                            :disabled="inProgress">
                                            CSVダウンロード
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-else
                            class="d-flex justify-content-center align-items-center p-5">
                            <b-spinner variant="yokumiru-admin"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <add-doctor-modal :env="env"/>
        <edit-doctor-modal :env="env"/>
        <unrestrict-doctor-modal/>
        <stop-doctor-modal/>
        <comeback-doctor-modal/>
        <delete-doctor-modal/>

        <admin-doctor-profile-modal/>
    </div>
</template>

<script>
    import constants from '../../constants'
    import { mapMutations } from 'vuex'

    export default {
        props: {
            env: {
                type: String,
                required: true,
            },
        },

        data: function() {
            return {
                inProgress: false,
                doctors: null,
                medicalCourses: [],
                doctorManagementTags: [],
                orders: constants.orders,
                search: {
                    medical_course_id: null,
                    doctor_management_tag_id: null,
                    prefecture: null,
                    freeword: '',
                    registered_at_gte: null,
                    registered_at_lte: null,
                    status: null,
                },
                prefmap: [
                    '北海道',   '青森県',   '岩手県',   '宮城県',
                    '秋田県',   '山形県',   '福島県',   '茨城県',   '栃木県',
                    '群馬県',   '埼玉県',   '千葉県',   '東京都',   '神奈川県',
                    '新潟県',   '富山県',   '石川県',   '福井県',   '山梨県',
                    '長野県',   '岐阜県',   '静岡県',   '愛知県',   '三重県',
                    '滋賀県',   '京都府',   '大阪府',   '兵庫県',   '奈良県',
                    '和歌山県', '鳥取県',   '島根県',   '岡山県',   '広島県',
                    '山口県',   '徳島県',   '香川県',   '愛媛県',   '高知県',
                    '福岡県',   '佐賀県',   '長崎県',   '熊本県',   '大分県',
                    '宮崎県',   '鹿児島県', '沖縄県',
                ],
                freeword: '',
                statusItems: [
                    '利用中',
                    '利用停止中',
                    '利用制限中',
                ],
                sortBy: 'id',
                sortDesc: false,
                paginationConf: {
                    currentPage: 1,
                    perPage: 10,
                    totalRows: 0,
                    from: 0,
                    to: 0,
                },
                fields: [
                    {
                        'key': 'id',
                        'label': '#',
                        sortable: true,
                    },
                    {
                        'key': 'full_name_kana',
                        'label': '医師名',
                        sortable: true,
                    },
                    {
                        'key': 'medical_course.name',
                        'label': `${this.$locale.consultation_host}科`,
                        sortable: false,
                    },
                    {
                        'key': 'doctor_management_tags.name',
                        'label': '管理用タグ',
                        sortable: false,
                    },
                    {
                        'key': 'status',
                        'label': 'ステータス',
                        sortable: false,
                    },
                    {
                        'key': 'address',
                        'label': '住所',
                        sortable: false,
                    },
                    {
                        'key': 'priority_num',
                        'label': '表示優先度',
                        sortable: true,
                    },
                    {
                        'key': 'sms_setting',
                        'label': 'SMS設定',
                        sortable: false,
                    },
                    {
                        'key': 'links',
                        'label': '',
                        'class': 'text-center',
                    },
                ],
            }
        },

        computed: {
            /**
             * ページング詳細表示
             * @returns {string}
             */
            dispPaginationDetail: function () {
                if ( this.$store.state.adminDoctors.total < 1 ) {
                    return ''
                }
                return `全${this.$store.state.adminDoctors.total}件中 ${this.$store.state.adminDoctors.from}～${this.$store.state.adminDoctors.to}件表示`
            },
        },

        created: function () {
            this.initQueryFromState()
            this.initSearchCondition()

            this.fetchDoctors()
            this.fetchMedicalCourses()
            this.fetchDoctorManagementTags()

            bus.$on('fetch-doctors', this.fetchDoctors)
        },

        mounted: function () {
            // 初回ログイン時のパスワード更新後アラート
            if (this.$store.state.adminMode.isResetPassword) {
                this.setIsResetPassword(false)
                bus.$emit('alert-info', '初回ログイン設定が完了しました。')
            }
        },

        methods: {
            ...mapMutations({
                setIsResetPassword: 'adminMode/setIsResetPassword',
                setQuery: 'adminDoctors/setQuery',
                setQueries: 'adminDoctors/setQueries',
            }),

            /**
             * 検索条件の初期化
             */
            initQueryFromState: function () {
                if (localStorage.getItem('yokumiruWeb')) {
                    const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                    if (data.adminDoctors) {
                        this.setQueries(data.adminDoctors)
                    }
                }
            },

            /**
             * 検索条件の初期化
             */
            initSearchCondition: function () {
                this.search.medical_course_id = this.$store.state.adminDoctors.medical_course_id
                this.search.doctor_management_tag_id = this.$store.state.adminDoctors.doctor_management_tag_id
                this.search.prefecture = this.$store.state.adminDoctors.prefecture
                this.search.freeword = this.$store.state.adminDoctors.freeword
                this.search.registered_at_gte = this.$store.state.adminDoctors.registered_at_gte
                this.search.registered_at_lte = this.$store.state.adminDoctors.registered_at_lte
                this.search.status = this.$store.state.adminDoctors.status
            },

            onChangeSearchMedicalCourseId: async function () {
                await this.setQuery({ key: 'medical_course_id', value: this.search.medical_course_id })
                await this.fetchDoctors(1)
            },

            onChangeSearchDoctorManagementTagId: async function () {
                await this.setQuery({ key: 'doctor_management_tag_id', value: this.search.doctor_management_tag_id })
                await this.fetchDoctors(1)
            },

            onChangeSearchPrefecture: async function () {
                await this.setQuery({ key: 'prefecture', value: this.search.prefecture })
                await this.fetchDoctors(1)
            },

            onChangeSearchFreeword: async function () {
                await this.setQuery({ key: 'freeword', value: this.search.freeword })
                await this.fetchDoctors(1)
            },

            onChangeSearchStatus: async function () {
                await this.setQuery({ key: 'status', value: this.search.status })
                await this.fetchDoctors(1)
            },

            onChangeSearchRegisteredAtGte: async function () {
                await this.setQuery({ key: 'registered_at_gte', value: this.search.registered_at_gte })
                await this.fetchDoctors(1)
            },

            onChangeSearchRegisteredAtLte: async function () {
                await this.setQuery({ key: 'registered_at_lte', value: this.search.registered_at_lte })
                await this.fetchDoctors(1)
            },

            /**
             * 医師一覧取得
             *
             * @param {number|object} param
             */
            fetchDoctors: async function (param = null) {
                if (this.inProgress) return
                this.inProgress = true

                this.doctors = null

                if (Number.isInteger(param) && param > 0) {
                    await this.setQuery({key: 'current_page', value: param})
                }
                else if (param !== null && param.hasOwnProperty('sortBy')) {
                    await this.setQuery({key: 'sortBy', value: param.sortBy})
                    await this.setQuery({key: 'sortDesc', value: param.sortDesc})
                }

                const endpoint = constants.admin.doctors.endpoint.base

                await axios.get(`${endpoint}${this.buildQuery()}`)
                    .then(({data}) => {
                        this.doctors = data.data
                        this.setQuery({key: 'current_page', value: data.current_page})
                        this.setQuery({key: 'per_page', value: data.per_page})
                        this.setQuery({key: 'total', value: data.total})
                        this.setQuery({key: 'from', value: data.from})
                        this.setQuery({key: 'to', value: data.to})
                    })

                this.inProgress = false
            },

            /**
             * QueryString生成
             *
             * @param {boolean} paginate
             * @return {string}
             */
            buildQuery: function (paginate = true) {
                let query = '?'

                const state = this.$store.state.adminDoctors

                if (paginate) {
                    query += `page=${state.current_page}`
                }
                query += `&sort=${state.sortBy}`
                query += `&desc=${state.sortDesc}`

                if (state.medical_course_id) {
                    query += `&medical_course_id=${state.medical_course_id}`
                }
                if (state.doctor_management_tag_id) {
                    query += `&doctor_management_tag_id=${state.doctor_management_tag_id}`
                }
                if (state.prefecture) {
                    query += `&prefecture=${state.prefecture}`
                }
                if (state.freeword && state.freeword.length > 0) {
                    query += `&freeword=${state.freeword}`
                }
                if (state.registered_at_gte) {
                    query += `&registered_at_gte=${state.registered_at_gte}`
                }
                if (state.registered_at_lte) {
                    query += `&registered_at_lte=${state.registered_at_lte}`
                }
                if (state.status) {
                    query += `&status=${state.status}`
                }

                return query
            },

            /**
             * 相談科一覧取得
             */
            fetchMedicalCourses: function () {
                axios.get(`${constants.admin.medical_courses.endpoint.base}?show=1`)
                    .then(({data}) => {
                        this.medicalCourses = data
                    })
            },

            /**
             * 医師管理用タグ一覧取得
             */
            fetchDoctorManagementTags: function () {
                axios.get(constants.admin.doctor_management_tags.endpoint.base)
                    .then(({data}) => {
                        this.doctorManagementTags = data
                    })
            },

            /**
             * 所属相談科の表示
             * @param {object} courses
             */
            medicalCoursesFormat: function (courses) {
                let result = ''

                courses.forEach((course) => {
                    result += `${course.name}、`
                })

                return result.length > 0 ? result.slice(0, -1) : result
            },

            /**
             * 利用制限モーダル表示
             */
            showModalUnrestrictDoctor: function (data) {
                bus.$emit('open-modal-unrestrict-doctor', data);
            },

            /**
             * 利用停止モーダル表示
             */
            showModalStopDoctor: function (data) {
                bus.$emit('open-modal-stop-doctor', data);
            },

            /**
             * 利用再開モーダル表示
             */
            showModalComebackDoctor: function (data) {
                bus.$emit('open-modal-comeback-doctor', data);
            },

            /**
             * 削除モーダル表示
             */
            showModalDeleteDoctor: function (data) {
                bus.$emit('open-modal-delete-doctor', data);
            },

            /**
             * 追加モーダル表示
             */
            showModalAddDoctor: function () {
                bus.$emit('open-modal-add-doctor')
            },

            /**
             * 編集モーダル表示
             *
             * @param {object} doctor
             */
            showModalEditDoctor: function (doctor) {
                bus.$emit('open-modal-edit-doctor', doctor, this.medicalCourses)
            },

            /**
             * 詳細モーダル表示
             */
            showModalDoctorProfile: function (doctor,event) {
                event.preventDefault();
                bus.$emit(
                    'open-modal-admin-doctor-profile',
                    doctor,
                )
            },

            /**
             * CSVダウンロード
             */
            downloadCSV: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const endpoint = `${constants.admin.doctors.endpoint.base}/export${this.buildQuery(false)}`
                const options = { responseType : 'blob' }

                await axios.get(endpoint, options)
                    .then((response) => {
                        const blob = new Blob([response.data], {
                            type: response.data.type,
                        })
                        saveAs(
                            blob,
                            sprintf(
                                '医師一覧_%s.csv',
                                moment().format('YYYYMMDD')
                            )
                        )
                    })
                    .catch(() => {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    })

                this.inProgress = false
            },
        },
    };
</script>

<style lang="scss">
.doctorManagementTagsWrapper {
    overflow-x: scroll;
    white-space: pre;
    width: 140px;
    padding: 5px 0;
    box-sizing: border-box;

    .doctorManagementTag {
        padding: 3px 5px;
        margin-right: 5px;
        color: #3461b4;
        font-size: .85em;
        background-color: #f2f4f8;
        border: 1px solid #dce4ed;
        border-radius: 2px;
    }
}

.adminDoctorsIndexTable {
    table {
        min-width: 1320px;

        th {
            font-size: .75rem;

            &:nth-child(1) {
                width: 50px;
            }
            &:nth-child(2) {
                min-width: 140px;
            }
            &:nth-child(4) {
                width: 140px;
            }
            &:nth-child(6) {
                width: 100px;
            }
            &:nth-child(7) {
                width: 300px;
            }
        }

        td {
            &:nth-child(1),
            &:nth-child(3),
            &:nth-child(4),
            &:nth-child(5),
            &:nth-child(6),
            &:nth-child(7),
            &:nth-child(8) {
                font-size: .75rem;
            }
        }
    }
}
</style>
